export const BetBuilderFeatureFlags = {
    Enabled: 'sports-offer.bet-builder-v1-enabled',
    EventCardLabelEnabled: 'sports-offer.bet-builder-v1-event-card-indicator-enabled',
    OnboardingEnabled: 'sports-offer.bet-builder-v1-onboarding-enabled',
    CrossSellingFromSuperbetsBannerEnabled: 'sports-offer.superbets-to-bet-builder-banner-enabled',
} as const;
export type BetBuilderFeatureFlags = typeof BetBuilderFeatureFlags[keyof typeof BetBuilderFeatureFlags];
